import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "state-seal-row" }
const _hoisted_2 = { class: "state-seal-name" }
const _hoisted_3 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.changeable ? 'button' : 'span'), {
      type: _ctx.changeable ? 'button' : undefined,
      class: _normalizeClass(["state-seal", [_ctx.surface, _ctx.ink, {'state-seal--action': _ctx.changeable}]]),
      title: _ctx.changeable ? _ctx.changeLabel : undefined,
      "aria-label": _ctx.changeable ? _ctx.changeLabel : undefined,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeable && _ctx.$emit('change')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, {
          size: "small",
          color: _ctx.dot
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.VALUE_DOT), 1)
          ]),
          _: 1
        }, 8, ["color"]),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.state.name), 1),
        (_ctx.changeable)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              size: "small",
              class: "state-seal-chevron"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-chevron-down", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["type", "class", "title", "aria-label"])),
    (_ctx.since)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "text-caption text-medium-emphasis",
          title: _ctx.sinceExact
        }, _toDisplayString(_ctx.sinceText), 9, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}